import { HistoriqueComponent } from './historique.component';

export const HISTORIQUE_ROUTES = [
    {
        path: '',
        component: HistoriqueComponent,
        data: {
            menu: {
                libelle: 'Historique des lots'
            }
        }
    }
];
